import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.autoSelectHandler = this.autoSelect.bind(this)
    this.element.addEventListener("click", this.autoSelectHandler)
  }

  disconnect() {
    this.element.removeEventListener("click", this.autoSelectHandler)
  }

  autoSelect(event) {
    event.currentTarget.select?.()
  }
}
